var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('overlay-layout',{attrs:{"close-route":"/programm"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.eventData.event.details)}}),_vm._v(" "),_c('gallerie',{attrs:{"thumbs":_vm.eventData.thumbs,"images":_vm.eventData.images}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }